var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { isEqual } from 'lodash';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Group } from '@/models/Group';
import { RolesEnum } from '@/items/Roles';
let StudentSelected = class StudentSelected extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.defaultFilters = {
            depth: 0,
        };
        this.isLoading = true;
        this.items = [];
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    // #endregion
    // #region Class methods
    setSelectItems() {
        if (!this.group) {
            return;
        }
        this.isLoading = true;
        if (this.group && this.group.users && this.group.users.length > 0) {
            this.items = this.group.users.filter((user) => {
                if (!user.roles) {
                    return false;
                }
                return user.roles.every((role) => {
                    return role.id === RolesEnum.STUDENT;
                });
            });
            this.sortSelectItems();
        }
        else {
            this.items = [];
        }
        this.isLoading = false;
    }
    sortSelectItems() {
        this.items.sort((a, b) => {
            const aFirstName = a.first_name?.toLowerCase() || '';
            const bFirstName = b.first_name?.toLowerCase() || '';
            const aLastName = a.last_name?.toLowerCase() || '';
            const bLastName = b.last_name?.toLowerCase() || '';
            return aFirstName.localeCompare(bFirstName) || aLastName.localeCompare(bLastName);
        });
    }
    // #endregion
    // #region Async methods
    async onInput(value) {
        if (isEqual(this.value, value)) {
            return;
        }
        this.$emit('input', value);
    }
    // #endregion
    // #region Getters & Setters
    // #endregion
    // #region @Watchers
    onGroupChange() {
        if (Object.keys(this.group).length > 0) {
            this.setSelectItems();
        }
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", String)
], StudentSelected.prototype, "value", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], StudentSelected.prototype, "useMorePadding", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], StudentSelected.prototype, "group", void 0);
__decorate([
    Watch('group', { immediate: true, deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], StudentSelected.prototype, "onGroupChange", null);
StudentSelected = __decorate([
    Component({})
], StudentSelected);
export default StudentSelected;
